/**
 * StuckKeyService
 * 
 * Detects keys that remain pressed beyond a reasonable duration (default 5s).
 */
export class StuckKeyService extends EventTarget {
  constructor() {
    super();
    this.stuckThreshold = 5000; // 5 seconds
    this.activeTimers = new Map(); // code -> timeoutId
    this.stuckKeys = new Set();
  }

  setThreshold(ms) {
    this.stuckThreshold = ms;
  }

  recordKeyDown(code) {
    // If already tracked, ignore (might be auto-repeat)
    if (this.activeTimers.has(code)) return;

    const timeoutId = setTimeout(() => {
      this.flagStuck(code);
    }, this.stuckThreshold);

    this.activeTimers.set(code, timeoutId);
  }

  recordKeyUp(code) {
    if (this.activeTimers.has(code)) {
      clearTimeout(this.activeTimers.get(code));
      this.activeTimers.delete(code);
    }

    if (this.stuckKeys.has(code)) {
      this.stuckKeys.delete(code);
      this.dispatchEvent(new CustomEvent('stuckresolved', { detail: { code } }));
    }
  }

  flagStuck(code) {
    this.stuckKeys.add(code);
    this.dispatchEvent(new CustomEvent('stuckdetected', { detail: { code } }));
  }

  clearAll() {
    this.activeTimers.forEach(id => clearTimeout(id));
    this.activeTimers.clear();
    this.stuckKeys.clear();
  }

  isKeyStuck(code) {
    return this.stuckKeys.has(code);
  }
}

export const stuckKeyService = new StuckKeyService();
